import React from 'react'
import ServiceSection from '../../Components/mumbai/ServiceSection';
import ServiceNowConsultingSlider from '../../Components/mumbai/ServiceNowConsultingSlider';
import MaximizeModal from '../../Components/mumbai/MaximizeModal';
import IndustriesSliderSection from '../../Components/mumbai/IndustriesSliderSection';
import ServiceNowBannerSection from '../../Components/mumbai/ServiceNowBannerSection';
import { Helmet } from 'react-helmet-async'
import HireDeveloper from '../../Components/hire/HireDeveloper';
import HeroServiceSection from '../../Components/mumbai/HeroServiceSection';
import LocationForm from '../../Components/mumbai/LocationForm';
import WhyChoose from '../../Components/mumbai/WhyChoose';
import EngagementModels from '../../Components/hire/EngagementModels';
import ServiceNowLeadForm from '../../Components/ServiceNowLeadForm';


const wellbeingData = [
    {
        id: 1,
        title: "Comprehensive Support",
        description: "Mobikode's Dubai team delivers reliable support, timely solutions, and dedicated partnership to help your business thrive confidently.",
        image: "/assets/mumbai/img2.png"
    },
    {
        id: 2,
        title: "Industry Expertise ",
        description: "Mobikode delivers tailored digital solutions that help Dubai businesses across healthcare, finance, retail, logistics, education, and real estate innovate, grow, and succeed confidently.",
        image: "/assets/mumbai/img2.png"
    },
    {
        id: 3,
        title: "Customized Solutions",
        description: "Every Dubai business deserves tailored digital solutions that simplify operations, accelerate growth, and deliver lasting business success.",
        image: "/assets/mumbai/img2.png"
    },

];


const consultingData = [
    {
        id: 1,
        title: "ServiceNow Consulting",
        desc: "Strategic platform advisory, maturity assessments, and digital roadmap formulation tailored to optimize your ServiceNow enterprise landscape.",
        link: "/service/servicenow-consulting",
    },
    {
        id: 2,
        title: "ServiceNow Implementation",
        desc: "End-to-end multi-module deployment, configuration, and workflow automation executed with best practices for swift enterprise adoption.",
        link: "/service/servicenow-implementation",
    },
    {
        id: 3,
        title: "ServiceNow ITSM",
        desc: "Modernize service desk operations, incident triage, change management, and request fulfillment through intelligent IT service management.",
        link: "/service/servicenow-itsm",
    },
    {
        id: 4,
        title: "ServiceNow ITOM & CMDB",
        desc: "Gain real-time infrastructure visibility, build an accurate healthy CMDB, and automate event remediation with predictive discovery.",
        link: "/service/servicenow-itom-cmdb",
    },
    {
        id: 5,
        title: "ServiceNow CSM",
        desc: "Deliver connected customer experiences by breaking down silos across front, middle, and back-office teams with proactive issue resolution.",
        link: "/service/servicenow-csm",
    },
    {
        id: 6,
        title: "ServiceNow HRSD",
        desc: "Elevate employee experiences with streamlined onboarding, unified life-event journeys, and self-service HR service delivery portals.",
        link: "/service/servicenow-hrsd",
    },
    {
        id: 7,
        title: "ServiceNow AI & Automation",
        desc: "Leverage Generative AI, Now Assist, machine learning models, and virtual agents to automate complex multi-departmental workflows.",
        link: "/service/servicenow-ai-automation",
    },
    {
        id: 8,
        title: "ServiceNow Integration",
        desc: "Seamlessly integrate your ServiceNow instance with ERPs, CRMs, cloud platforms, and legacy systems via Integration Hub and custom APIs.",
        link: "/service/servicenow-integration",
    },
    {
        id: 9,
        title: "ServiceNow Custom Development",
        desc: "Build scalable, tailor-made applications and intuitive enterprise service portals using ServiceNow App Engine and UI Builder.",
        link: "/service/servicenow-custom-development",
    },
    {
        id: 10,
        title: "ServiceNow Managed Services",
        desc: "Continuous proactive support, performance monitoring, release upgrades, technical debt reduction, and platform governance.",
        link: "/service/servicenow-managed-services",
    },
    {
        id: 11,
        title: "ServiceNow Resource Augmentation",
        desc: "Scale your delivery bandwidth with certified ServiceNow architects, developers, technical consultants, and flexible dedicated pods.",
        link: "/service/servicenow-resource-augmentation",
    },
    {
        id: 12,
        title: "ServiceNow Center of Excellence (COE)",
        desc: "Build a scalable ServiceNow ecosystem with strong governance, platform standardization, continuous improvement, and enterprise-wide innovation.",
        link: "/service/servicenow-coe",
    },
];

const industriesData = [
    {
        id: 1,
        title: "Financial Services",
        desc: "Mobikode empowers financial businesses across Dubai with secure, innovative technology solutions that streamline operations, enhance customer experiences, boost efficiency, and support confident, sustainable business growth.",
        image: "/assets/mumbai/item1.png"
    },
    {
        id: 2,
        title: "eCommerce ",
        desc: "Mobikode helps Dubai eCommerce businesses grow with reliable digital solutions, seamless customer experiences, smarter operations, and innovative technology that drives sustainable success and long-term business growth.",
        image: "/assets/mumbai/item2.png"
    },
    {
        id: 3,
        title: "Insurance ",
        desc: "Helping Dubai's insurance providers modernize operations, enhance customer experiences, simplify claims and policy management, and achieve sustainable growth with secure, reliable, and innovative digital solutions.",
        image: "/assets/mumbai/item3.png"
    },
    {
        id: 4,
        title: "Manufacturing",
        desc: "At Mobikode, we help Dubai's manufacturing businesses adopt smart digital solutions, streamline operations, boost productivity, optimize workflows, and achieve sustainable growth with confidence and efficiency.",
        image: "/assets/mumbai/item4.png"
    },
    {
        id: 5,
        title: "Retail & Consumer Goods",
        desc: "Mobikode empowers Dubai's retail and consumer brands with smart digital solutions that enhance customer experiences, streamline operations, boost efficiency, and drive sustainable business growth confidently.",
        image: "/assets/mumbai/item5.png"
    },
    {
        id: 6,
        title: "Healthcare & Life Sciences",
        desc: "At Mobikode, we help healthcare and life sciences organizations in Dubai transform patient care with intelligent digital solutions, streamlined operations, and secure technologies that deliver better health outcomes.",
        image: "/assets/mumbai/item6.png"
    },
    {
        id: 7,
        title: "Media & Communications ",
        desc: "Mobikode empowers Dubai's media and communications businesses with innovative digital solutions that enhance audience engagement, streamline operations, strengthen brand presence, and deliver exceptional customer experiences through technology.",
        image: "/assets/mumbai/item7.png"
    },
    {
        id: 8,
        title: "Logistics & Transportation ",
        desc: "At Mobikode, we help Dubai's logistics and transportation businesses streamline operations, optimize deliveries, enhance customer experiences, and accelerate growth with reliable, innovative digital solutions.",
        image: "/assets/mumbai/item8.png"
    },
    {
        id: 9,
        title: "Technology",
        desc: "At Mobikode, we help Dubai's technology companies transform ideas into innovative digital solutions, delivering scalable, reliable technology that accelerates growth, enhances efficiency, and drives lasting success.",
        image: "/assets/mumbai/item9.png"
    },
    {
        id: 10,
        title: "Non Profit",
        desc: "At Mobikode, we empower non-profit organizations across Dubai with smart digital solutions that streamline operations, strengthen community engagement, and maximize their impact through meaningful innovation.",
        image: "/assets/mumbai/item10.png"
    },
    {
        id: 11,
        title: "Professional Services ",
        desc: "Mobikode helps professional service businesses in Dubai simplify operations, adopt smart digital solutions, improve client experiences, boost productivity, and achieve sustainable growth with confidence and innovation.",
        image: "/assets/mumbai/item11.png"
    },
    {
        id: 12,
        title: "Real Estate ",
        desc: "Mobikode helps Dubai’s real estate businesses thrive with smart digital solutions that streamline operations, enhance customer experiences, and build meaningful connections between developers, agents, and buyers.",
        image: "/assets/mumbai/item12.png"
    },

];

function Dubai() {
    return (
        <div>
            <Helmet>
                <title>
                    ServiceNow Consulting in Dubai | IT Operations & Automation | Mobikode
                </title>

                <meta
                    name="description"
                    content="Mobikode offers ServiceNow consulting in Dubai to modernize IT operations, automate business workflows, enhance service management, and help organizations build scalable digital processes."
                />

                <meta
                    name="keywords"
                    content="ServiceNow Consulting Dubai, ServiceNow Consultant Dubai, ServiceNow ITSM Dubai, ServiceNow IT Operations Dubai, ServiceNow Business Automation Dubai, ServiceNow Workflow Automation Dubai, ServiceNow Implementation Dubai, ServiceNow Integration Dubai, ServiceNow Managed Services Dubai, ServiceNow Digital Transformation Dubai"
                />

                <link
                    rel="canonical"
                    href="https://www.mobikode.com/location/leverage-serviceNow-consulting-in-dubai"
                />

                <meta
                    property="og:title"
                    content="ServiceNow Consulting in Dubai | IT Operations & Automation | Mobikode"
                />

                <meta
                    property="og:description"
                    content="Modernize your business operations with Mobikode's ServiceNow consulting services in Dubai. Streamline IT processes, automate workflows, improve service management, and create scalable digital solutions."
                />

                <meta
                    property="og:url"
                    content="https://www.mobikode.com/location/leverage-serviceNow-consulting-in-dubai"
                />

                <meta
                    property="og:type"
                    content="website"
                />

                <meta
                    property="og:image"
                    content="https://www.mobikode.com/assets/dubai/bg1.png"
                />

                <meta
                    name="twitter:card"
                    content="summary_large_image"
                />

                <meta
                    name="twitter:title"
                    content="ServiceNow Consulting in Dubai | Mobikode"
                />

                <meta
                    name="twitter:description"
                    content="Explore ServiceNow solutions in Dubai for IT operations, workflow automation, service management, system integration, and digital transformation with Mobikode."
                />

                <meta
                    name="twitter:image"
                    content="https://www.mobikode.com/assets/dubai/bg1.png"
                />
            </Helmet>
            <HeroServiceSection bgImage="/assets/mumbai/bg1.png" title="Leverage ServiceNow Consulting in Dubai" description="Partner with Mobikode’s ServiceNow experts in Dubai to simplify daily operations, empower your teams, automate business processes, and achieve sustainable growth through intelligent digital transformation. Trusted by Startups and Leading Companies Worldwide" />
            <ServiceNowLeadForm bgImage="/assets/mumbai/Dubai.png" />
            <ServiceNowConsultingSlider consultingData={consultingData} />
            <WhyChoose />
            <MaximizeModal wellbeingData={wellbeingData} />
            <EngagementModels />
            <IndustriesSliderSection industriesData={industriesData} />

            {/* <section className="relative w-full h-[500px] lg:h-[630px] flex items-center bg-[#000814] overflow-hidden py-12 md:py-0">
                <div className="absolute inset-0 z-0">
                    <img
                        src="/assets/mumbai/bg1.png"
                        alt="Abstract 3D Background"
                        className="w-full h-full object-cover"
                    />
                    <div
                        style={{ background: "linear-gradient(86.84deg, #000000 20%, rgba(0, 0, 0, 0) 79%)" }}
                        className="hidden md:block absolute inset-0"
                    ></div>
                    <div
                        style={{ background: "linear-gradient(0deg, #000000 40%, rgba(0, 0, 0, 0.3) 100%)" }}
                        className="block md:hidden absolute inset-0"
                    ></div>
                </div>

                <div className="relative z-10 w-full max-w-[1440px] mx-auto px-[20px] md:px-[40px] lg:px-[80px] flex flex-col items-start justify-center h-full">
                    <div className="w-full max-w-[500px] md:max-w-[700px] lg:max-w-[900px] mt-auto md:mt-0">
                        <h1 className="text-white font-[600] text-[28px] sm:text-[36px] md:text-[50px] lg:text-[60px] font-sora leading-[1.2] lg:leading-[1.1] mb-[12px] lg:mb-[22px] drop-shadow-xl tracking-wide text-left">
                            Leverage ServiceNow Consulting in Dubai
                        </h1>
                        <p className="text-[#FFFFFF] max-w-[800px] w-full text-[14px] sm:text-[16px] md:text-[18px] leading-[20px] md:leading-[22px] lg:leading-[24px] font-graphik font-light tracking-wider text-left opacity-90 lg:opacity-100">
                            Empower your Dubai business with Mobikode's ServiceNow expertise to streamline operations, automate workflows, boost productivity, and achieve sustainable business growth with confidence.
                        </p>
                    </div>
                </div>
            </section>
            <ServiceSection image={"/assets/mumbai/Dubai.png"}
                text={"At Mobikode, we help businesses across Dubai unlock the full potential of ServiceNow with tailored consulting, seamless implementation, and intelligent automation. Our experts simplify complex workflows, streamline operations, and integrate systems to improve productivity and user experiences. We deliver scalable, future-ready ServiceNow solutions that support sustainable business growth and digital transformation."}
                title={"ServiceNow Consulting"} />
            <ServiceNowConsultingSlider consultingData={consultingData} />
            <MaximizeModal wellbeingData={wellbeingData} />
            <IndustriesSliderSection industriesData={industriesData} />
            <ServiceNowBannerSection imgs={"/assets/mumbai/img3.png"}
                title="ServiceNow Consulting Services"
                text="Mobikode helps Dubai businesses unlock ServiceNow’s potential through tailored consulting, intelligent automation, and seamless digital solutions that simplify operations, enhance productivity, and deliver better experiences." />
            <HireDeveloper /> */}
        </div>
    )
}

export default Dubai
